/**
 * Device Fingerprinting utility using FingerprintJS
 * Used for ban evasion prevention
 */
import FingerprintJS from '@fingerprintjs/fingerprintjs';

console.log('[Fingerprint Module] Loaded');

let fpPromise = null;

/**
 * Initialize FingerprintJS (call once on app load)
 */
export const initFingerprint = async () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

/**
 * Get the device fingerprint
 * @returns {Promise<string>} The visitor ID (fingerprint)
 */
export const getFingerprint = async () => {
  try {
    console.log('[Fingerprint] Starting fingerprint capture...');
    const fp = await initFingerprint();
    console.log('[Fingerprint] FingerprintJS loaded');
    const result = await fp.get();
    console.log('[Fingerprint] Got visitor ID:', result.visitorId);
    return result.visitorId;
  } catch (error) {
    console.error('[Fingerprint] Error getting fingerprint:', error);
    return null;
  }
};

/**
 * Get detailed fingerprint components (for debugging)
 * @returns {Promise<object>} Detailed fingerprint data
 */
export const getFingerprintDetails = async () => {
  try {
    const fp = await initFingerprint();
    const result = await fp.get();
    return {
      visitorId: result.visitorId,
      confidence: result.confidence?.score || 0,
      components: result.components,
    };
  } catch (error) {
    console.error('Error getting fingerprint details:', error);
    return null;
  }
};
